import React, { useEffect, useRef, useState } from "react";
import { useLocalStorage } from "src/utils/use-local-storage";
import FileExplorer from "./file-explorer";
import { ArrowLeftIcon, ArrowRightIcon } from "./icons-svg";

export function CodeEditor(props) {
    const monacoObjects = useRef(null);
    const [decorations, setDecorations] = useState([]);
    const [expandFileExplorer, setExpandFileExplorer] = useLocalStorage("expandFileExplorer", true);

    const [monacoOptions, setMonacoOptions] = useState({
        autoIndent: "full",
        automaticLayout: true,
        contextmenu: true,
        fontFamily: "monospace",
        fontSize: 13,
        lineHeight: 24,
        hideCursorInOverviewRuler: true,
        matchBrackets: "always",
        minimap: {
            enabled: true,
        },
        readOnly: props.readOnly,
        scrollbar: {
            horizontalSliderSize: 18,
            verticalSliderSize: 18,
        }
    })

    const editorDidMount = async (editor, monaco) => {
        monacoObjects.current = {
            editor,
            monaco,
        };
        if (editor && editor.getModel()) {
            const editorModel = editor.getModel();
            if (editorModel) {
                editorModel.setValue(props.code);
            }
        }
        editor.focus();

        //monaco.editor.setTheme('vs-dark');

        monaco.languages.register({ id: "solidity" })

        if(props.cursorPosition){
            editor.setPosition(props.cursorPosition);
            editor.revealLineInCenter(props.cursorPosition.lineNumber);
        }

        if (props.saveCursorPosition) {
            editor.onDidChangeCursorSelection((e) => {
                props.saveCursorPosition(editor.getPosition());
            });
        }

    };

    const onChange = (newCode, event) => {
        console.log('onChange', newCode);
    };

    useEffect(() => {
        if (!monacoObjects.current || !props.highlightRange) {
            return;
        } else {
            const { monaco, editor } = monacoObjects.current;
            if (
                props.highlightRange.startLine == 1 &&
                props.highlightRange.startColumn == 1 &&
                props.highlightRange.endLine == 1 &&
                props.highlightRange.endColumn == 1
            ) {
                editor.deltaDecorations(decorations, []);
            } else {
                let deco = editor.deltaDecorations(
                    decorations,
                    [
                        {
                            range: new monaco.Range(
                                props.highlightRange.startLine,
                                props.highlightRange.startColumn,
                                props.highlightRange.endLine,
                                props.highlightRange.endColumn
                            ),
                            options: {
                                language: "solidity",
                                isWholeLine: false,
                                className: "myContentClass",
                                glyphMarginClassName: "myGlyphMarginClass",
                            }
                        },
                    ]
                );
                setDecorations(deco);
            }

        }
    }, [props.highlightRange]);


    return (
        <>

            <div css={`
                    display:flex;                  
                    height:100%;
                    `}>
                {
                    props.showFileExplorer &&
                    <>
                        {
                            expandFileExplorer &&
                            <div css={`
                            flex: 20%;
                            min-width: 170px;
                            height:100%;
                            `}>
                                <FileExplorer
                                    files={props.fileList}
                                    setFiles={props.setFileList}
                                    selectedFilePath={props.selectedFilePath}
                                    setSelectedFilePath={props.onFileChange}
                                />
                            </div>
                        }
                        {
                            props.showExpandCollapseButton &&
                            <div css={`
                                display: flex;
                                justify-content: right;`
                            }>
                                {
                                    expandFileExplorer ?
                                        <span css={`
                                color:#799fd4;
                                cursor: pointer;
                                text-decoration-line: underline;
                            `}
                                            onClick={() => { setExpandFileExplorer(false) }}>{ArrowLeftIcon}</span>
                                        :
                                        <span css={`
                                color:#799fd4;
                                cursor: pointer;
                                text-decoration-line: underline;
                            `}
                                            onClick={() => { setExpandFileExplorer(true) }}>{ArrowRightIcon}</span>
                                }
                            </div>
                        }
                    </>
                }

                <div css={`
                        flex: 80%;
                        width: 80%;
                        height:100%;
                        `}>
                    <style
                        dangerouslySetInnerHTML={{
                            __html: `
                    .myGlyphMarginClass {
                        background: red;
                    }
                    .myContentClass {
                        background: lightblue;
                    }
                    `,
                        }}
                    />
                    <MonacoReact
                        width="100%"
                        height="100%"
                        options={monacoOptions}
                        onChange={onChange}
                        value={props.code}
                        editorDidMount={editorDidMount}
                    />

                </div>
            </div>
        </>
    );
}